import VendedorTable from './VendedorTable';

export default VendedorTable;
